<template>
  <div>
    <v-dialog v-if="type == 1" v-model="showDocument" persistent scrollable @keydown.esc="close">
      <v-btn style="position: absolute; right: 20px; top: 20px; z-index: 100" fab dark small color="blue-grey" title="Закрыть окно" @click="close">
        <v-icon dark> mdi-close </v-icon>
      </v-btn>
      <v-card style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px; width: auto; margin: auto" height="auto">
        <component v-if="currentComponent" :is="currentComponent" v-bind="currentProps" :ref="docName" @close="close" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getAccess } from "@/components/mixings";

export default {
  mixins: [getAccess],
  components: {},
  props: {},
  data() {
    return {
      isQuickView_: true,
      idItemShow: 0,
      docName: "",
      showDocument: false,
      type: null,
      api: undefined,
      m: this.$store.getters["config/get"].models.quickOpenDocument,
      m2: {
        OrderGoods: { path: "/documents/views/orderGoodsView", props: { showOnly: true } },
        OrderService: { path: "/documents/views/orderServiceView", props: { showOnly: true } },
        LoanGet: { path: "/documents/views/loanGetView", props: { showOnly: !true } },
        CashDialog: { path: "/documents/dialogs/cashDialog" },
        ActWork: { path: "/documents/views/actWorkView", props: { showOnly: true } },
        AgentSell: { path: "/views/agentSellView", props: { showOnly: true } },
        ActWorkClient: { path: "/documents/views/actWorkClientView", props: { showOnly: true } },
        Task: { path: "/views/tasksView", props: { showOnly: !true } },
        Buying: { path: "/views/tasksBuyingView", props: { showOnly: !true } },
      },
    };
  },
  computed: {
    isQuickView() {
      return true;
    },
    currentComponent() {
      if (!this.docName) return null;
      const path = this.m?.[this.docName]?.path;
      if (!path) return null;
      return () =>
        import(`@/views${path}`).catch((e) => {
          console.error(e);
          this.$root.$emit("show-info", {
            type: "error",
            text: `Компонент @${path}.vue не найден`,
          });
        });
    },

    currentProps() {
      const props = this.m?.[this.docName]?.props || {};
      return {
        idShow: this.idItemShow,
        isQuickView: true,
        api: this.api,
        ...props,
        ...this.extraProps,
      };
    },
  },
  created() {},
  watch: {
    showDocument(v) {
      if (!v) {
        this.reset();
      }
    },
  },
  methods: {
    close() {
      this.showDocument = false;
    },
    reset() {
      this.idItemShow = 0;
      this.docName = "";
      this.type = null;
      this.api = undefined;
      this.extraProps = {};
      this.$emit("onClose");
    },
    async openDocument(name, id, row) {
      console.log({ name, id, row });
      if (name === "AccountingDocOrderWithdrawalModel" || name === "AccountingDocOrderReceiptModel") {
        return this.$refs.cashDialog.openDialog(name, id);
      }
      const config = this.m?.[name];

      if (!config) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Открытие этого документа в стадии разработки1",
        });
        return;
      }

      this.docName = name;
      this.idItemShow = id;
      this.api = row?._api;
      this.extraProps = config?.props || {};
      this.type = 1;
      this.$nextTick(() => {
        this.showDocument = true;
      });
    },
    itemShowClose() {},
  },
};
</script>
